import { render, staticRenderFns } from "./pointsRecord.vue?vue&type=template&id=d48e4ed8&scoped=true&"
import script from "./pointsRecord.vue?vue&type=script&lang=js&"
export * from "./pointsRecord.vue?vue&type=script&lang=js&"
import style0 from "./pointsRecord.vue?vue&type=style&index=0&id=d48e4ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48e4ed8",
  null
  
)

export default component.exports